<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Q8 Fuel on the Go"
        :has-back-button="true"
        :is-overlay="true"
      />
      <o-header-image image="images/q8-header.jpg" />
      <o-section-header title="Accountregistratie" />
      <o-section>
        <o-alert
          message="We gaan een account voor je aanmaken met onderstaand e-mailadres. Je moet dit wel nog bevestigen, dus check je mailbox."
        />
        <o-text-input label="E-mail" value="patrick.jansens@email.com" />
      </o-section>
      <o-section>
        <div class="u-flex">
          <o-text-input
            class="u-flex__flexible"
            label="Commerciële boodschappen"
            :custom="true"
          >
            <o-checkbox
              >Ik wens commerciële boodschappen te ontvangen via deze
              app.</o-checkbox
            >
          </o-text-input>
          <o-icon
            icon="info"
            class="u-primary"
            @click.native="$router.push('/sales/fuel/q8/onboarding/commercial')"
          />
        </div>
      </o-section>
    </o-view>
    <o-pay-button
      label="Verzend"
      to="/sales/fuel/q8/onboarding/confirmation "
    />
  </o-view>
</template>

<script>
import OHeaderImage from '@/components/OHeaderImage.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OHeaderImage,
    OPayButton
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss"></style>
